
<template>
  <div id="page-data-edit">

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.editId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-order-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="edit_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Maintenance Order Details" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab class="mt-4" :data="edit_data" />
            </div>
          </vs-tab>          
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import EditTab     from './EditTab.vue'
import axios from '@/axios'
import common from '@/common'
import mainHelper from '@/mainHelper' //crud

export default {
  components: {
    EditTab
  },
  data () {
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,
            
      edit_data: null,
      data_not_found: false,
      token: localStorage.usertoken,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_edit_data(this.$route.params.editId)
    }
  },
  methods: {
    fetch_edit_data (editId) {
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/order/view/${editId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-order-list'})
              } else {
                resolve(res['data'])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.$vs.loading.close()
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          if(typeof res == 'undefined') {
            this.data_not_found = true
          } else {            
            this.edit_data = res
            this.edit_data.assigned_to = parseInt(this.edit_data.assigned_to)
            this.edit_data.rfp_type = JSON.parse(this.edit_data.rfp_type)
            this.edit_data.questions_to_vendor = JSON.parse(this.edit_data.questions_to_vendor)
            this.edit_data.qoutation = JSON.parse(this.edit_data.qoutation)
            this.edit_data.rfp_recipients = JSON.parse(this.edit_data.rfp_recipients)
            this.edit_data.createdAt = common.formatDate(new Date(this.edit_data.createdAt))
            this.edit_data.rfp_issue_date = this.edit_data.rfp_issue_date === null ? null : common.formatDate(new Date(this.edit_data.rfp_issue_date))
            this.edit_data.approvals = this.edit_data.approval 
              ? this.edit_data.approval.approval_items.sort((a, b) => a.level - b.level) : []

            this.edit_data.maintenance_request_dts.filter((res) => {
              res.start_date = new Date(res.start_date)
              res.start_time = common.formatTime2(new Date('2021-01-01 ' + res.start_time))
              res.end_time = common.formatTime2(new Date('2021-01-01 ' + res.end_time))
            })
            console.log('this.edit_data ', this.edit_data)
          }
        }).catch(err => {
          if (err.response.status === 404) {
            this.edit_not_found = true
            return
          }
          reject(err) 
        })

      })
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('order-list', 'list')
    this.showC = await mainHelper.cansee('order-create', 'create')
    this.showR = await mainHelper.cansee('order-read', 'read')
    this.showU = await mainHelper.cansee('order-update', 'update')
    this.showD = await mainHelper.cansee('order-delete', 'delete')

    if (!this.showU) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }

    this.fetch_edit_data(this.$route.params.editId)
  }
}

</script>
